import gql from 'graphql-tag';

export const ORG_SURVEY_BY_ID_OPTIMIZED = gql`
  query SurveyById($id: ID!) {
    orgSurveyById:SurveyById(id: $id) {
        id
        name
        description
        termsConditions
        shuffle
        public
        activeFrom
        activeTo
        reportQuery
        multisourceResponse
        groupSet {
            edges {
                cursor
                node {
                    id
                    name
                    label
                    helpText
                    sequence
                    matrix
                    showInResult
                    showAvgInResult       
                    questionSet {
                        edges {
                            cursor
                            node {
                                id
                                questionText
                                required
                                helpText
                                sequence
                                questionAddress
                                numberOfAnswers
                                choiceSet {
                                    edges {
                                        cursor
                                        node {
                                            id
                                            label
                                            value
                                            sequence
                                            inputType
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
  }
`;
